const selectDeviceCoordinates = state => state.data.deviceCoordinates

const DeviceCoordinateDataStoreSelectors = {
  deviceCoordinates: selectDeviceCoordinates
}

export default DeviceCoordinateDataStoreSelectors
